import { axiosWithAuth } from "../../helpers";

export const scheduleAListService = {
	getScheduleAList,
	changeStatus,
	getCompanyScheduleAList,
	updateScheduleADefault,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getScheduleAList({
	userId,
	page = null,
	sortBy = null,
	sortDescending = null,
}) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy,
			ascending: sortDescending,
		},
		url: `${API_URL}/api/agents/${userId}/residuals/schedules/a/list`,
	};

	return axiosWithAuth(options);
}

function changeStatus({ userId, scheduleId, status }) {
	return axiosWithAuth({
		url: `${API_URL}/api/agents/${userId}/residuals/schedules/a/${scheduleId}/status`,
		method: "PUT",
		data: { status },
	});
}

function getCompanyScheduleAList({ companyId, agentId }) {
	const options = {
		method: "GET",
		params: {
			agent_id: agentId,
		},
		url: `${API_URL}/api/companies/${companyId}/residuals/schedules/a`,
	};

	return axiosWithAuth(options);
}

function updateScheduleADefault({ agentId, scheduleId, isDefault }) {
	return axiosWithAuth({
		url: `${API_URL}/api/agents/${agentId}/residuals/schedules/a/${scheduleId}/set_is_default`,
		method: "POST",
		data: { is_default: isDefault },
	});
}
